
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

import { CharThumbs, bottomRightBallonPosition, topLeftBallonPosition } from '_appRoot/index.const';

export default class LoginController {
    constructor($rootScope, $log, $state, $timeout, Session, Dialog, Trophies) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.Session = Session;
        this.Dialog = Dialog;
        this.Trophies = Trophies;

        this.state = {
            step: 1
        };

        this.ballons = {
            ballon1: {
                visible: false,
                thumb: CharThumbs.vernaculo,
                dialogs: [
                    'O mundo dos quadrinhos é um lugar pacífico. <br> Lá vivem todos os elementos que povoam os quadrinhos!',
                    'Neste mundo, destaca-se croma, a guardiã das cores e das formas. <br> Mas, nem tudo é perfeito... ',
                ],
                position: topLeftBallonPosition
            },
            ballon2: {
                visible: false,
                thumb: CharThumbs.abeldo,
                dialogs: [
                    'O tempo de paz acabou! <br> Eu, Albedo, acabarei com a harmonia no mundo dos quadrinhos!',
                    'E começarei por <b>esse livro</b>!',
                ],
                position: bottomRightBallonPosition
            },
            ballon3: {
                visible: false,
                thumb: CharThumbs.vernaculo,
                dialogs: [
                    'O que faremos agora, Croma?',
                    'A paz do mundo dos quadrinhos não estará completa se não conseguirmos recuperar as <b>páginas roubadas</b>!',
                ],
                position: bottomRightBallonPosition
            },
            ballon4: {
                visible: false,
                thumb: CharThumbs.croma,
                dialogs: [
                    'Não se preocupe, sábio vernáculo!',
                    'Eu seguirei o rastro cinzento de Albedo pela Estrada de Requadros e recuperarei as páginas.'
                ],
                position: bottomRightBallonPosition
            },
            ballon5: {
                visible: false,
                thumb: CharThumbs.vernaculo,
                dialogs: [
                    'Pegue este <b>mapa</b>! Ele guiará você até as páginas perdidas durante a sua passagem pela <b>Estrada de Requadros.</b> Boa jornada!',
                ],
                position: bottomRightBallonPosition
            }
        }
    }

    $onInit() {
        let data = this.Session.get();

        if (!_.isEmpty(data)) {
            this.$state.go("main");
        }
    }

    submit() {
        this.Session.create();
        this.$state.go('main');
    }

    toDialogs() {
        this.state.step++;

        this.$timeout(() => {
            this.ballons.ballon1.visible = true;
        }, 800);
    }

    onCloseBallon1() {
        this.ballons.ballon1.visible = false;
        this.ballons.ballon2.visible = true;
        this.state.step++;
    }
    onCloseBallon2() {
        this.ballons.ballon2.visible = false;
        this.ballons.ballon3.visible = true;
    }
    onCloseBallon3() {
        this.ballons.ballon3.visible = false;
        this.ballons.ballon4.visible = true;
    }
    onCloseBallon4() {
        this.ballons.ballon4.visible = false;
        this.ballons.ballon5.visible = true;
    }
    onCloseBallon5() {
        this.ballons.ballon5.visible = false;

        this.Session.create() // Create Session

        this.Dialog.showTrophy(false, () => {
            this.$state.go('main');
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/login/login.controller.js